import { gql } from "@apollo/client";

export const SEND_INVOICE_TO_ASSESSMENT = gql`
  mutation sendInvoiceToAssessment(
    $input: SendInvoiceToAssessmentInput!
    $clientIdentifier: String!
  ) {
    invoice {
      sendInvoiceToAssessment(
        input: $input
        clientIdentifier: $clientIdentifier
      ) {
        success
      }
    }
  }
`;
